import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
  ) { }

  parseFilters(filters: any) {
    if (filters && Object.keys(filters).length > 0) {
      const filtersItem = []
      for (const key of Object.keys(filters)) {
        filtersItem.push(`${key}=${filters[key]}`)
      }
      return filtersItem.join("&");
    } else {
      return ''
    }
  }

  postCall(url: string, body: any) {
    return firstValueFrom(this.http.post(url, body));
  }

  patchCall(url: string, body: any) {
    return firstValueFrom(this.http.patch(url, body));
  }

  getCall(url: string, params: any) {
    return firstValueFrom(this.http.get(url, { params }));
  }

}
